module.exports = __webpack_public_path__ + "static/img/7.a9340ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/7.jpg
// module id = LfcO
// module chunks = 1